import { render } from "@/components/pages/specialFeature/spWorkSupport/requirementSpCOM001/RequirementSpCOM001.html?vue&type=template&id=238b60f8&scoped=true&external"
import script from "@/components/pages/specialFeature/spWorkSupport/requirementSpCOM001/RequirementSpCOM001.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spWorkSupport/requirementSpCOM001/RequirementSpCOM001.js?vue&type=script&lang=js&external"

import "@/components/pages/specialFeature/spWorkSupport/requirementSpCOM001/RequirementSpCOM001.scss?vue&type=style&index=0&id=238b60f8&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238b60f8"]])

export default __exports__